'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import { getFetchBrandingCustomFonts } from 'tinymce-data/api/Fonts';
import FontSelect from 'rich-text-lib/components/formatting/fontSelect/StyledFontSelect';
import { memoize } from 'rich-text-lib/utils/functions';
import { hsformattingConfig, UnsupportedFonts } from '../constants/hsformatting';
import { getPluginSetting } from '../utils';
import { CANVAS_FONT_FAMILY } from '../constants/toolbar';
import { getFontSelectOptions, matchFont, calculateParsedFonts, constructParsedFontText, getHandleChangeFont, getCustomFontSelectOptions, addCustomFontPostProcessTransform, addCustomFontPreProcessTransform } from '../utils/formatting';
import { maybeGetComputedStyle } from '../utils/getComputedStyle';
import { HS_FORMATTING } from '../constants/plugins';
import { applyFontStyles } from './utils';
import { isUngated } from '../utils/settings';
import { jsx as _jsx } from "react/jsx-runtime";
export function addFontSelects(editor) {
  const {
    [hsformattingConfig.FONT_FORMATS]: fontFormats,
    [hsformattingConfig.WEBFONT_FORMATS]: webFontFormats,
    [hsformattingConfig.ENABLE_PARSED_FONTS]: enableParsedFonts,
    [hsformattingConfig.USE_PARSED_FONTS]: useParsedFonts
  } = getPluginSetting(editor, HS_FORMATTING);
  const defaultFonts = getFontSelectOptions(fontFormats.defaults);
  const customFonts = getCustomFontSelectOptions(fontFormats.customFonts || []);
  const webfonts = getFontSelectOptions(webFontFormats);
  const isEmail = getPluginSetting(editor, 'isEmail');
  addCustomFontPreProcessTransform(editor);
  let brandingFonts = [];
  const getBrandFonts = getFetchBrandingCustomFonts(editor.settings.apiClient);
  tinymce.canvas.addIdleCallback(editor, null, () => {
    getBrandFonts();
  });
  const addBrandingCustomFonts = fonts => {
    if (!brandingFonts.length && fonts.length) {
      brandingFonts = getCustomFontSelectOptions(fonts);
      const combinedCustomFonts = [...customFonts, ...brandingFonts];
      addCustomFontPostProcessTransform(editor, combinedCustomFonts);
    } else {
      //still need this if brand font fetch fails so that we still enable funstionality for custom fonts in the post process
      if (!brandingFonts.length && !fonts.length && customFonts.length) {
        addCustomFontPostProcessTransform(editor, customFonts);
      }
    }
  };
  editor.addCommand('hsfontselect', (_command, {
    value,
    isCustomFont
  }) => {
    const fontApplied = isCustomFont ? value.fontValue.optionValue : value;
    editor.formatter.apply('fontname', {
      value: fontApplied
    });
    if (isCustomFont) {
      applyFontStyles(editor, value.fontValue.styles);
    }
    editor.nodeChanged();
  });
  const getParsedFonts = memoize(calculateParsedFonts, _editor => _editor.id);
  const parsedFontText = constructParsedFontText(isEmail);
  const getFormattingAttributes = ({
    element
  }) => {
    const computedStyle = maybeGetComputedStyle(editor.getWin(), element);
    if (!computedStyle) {
      return {};
    }
    const {
      parsedFonts,
      fontsWithUsedUnsupportedFonts
    } = getParsedFonts(editor, useParsedFonts, defaultFonts, webfonts);
    const matched = matchFont(computedStyle.fontFamily, [...defaultFonts, ...customFonts, ...webfonts, ...parsedFonts, ...brandingFonts]);
    const value = matched ? matched.value : null;
    return {
      parsedFonts,
      fontsWithUsedUnsupportedFonts,
      [CANVAS_FONT_FAMILY]: value
    };
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    getFormattingAttributes
  });
  tinymce.canvas.addButton(editor, CANVAS_FONT_FAMILY, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        [CANVAS_FONT_FAMILY]: value,
        parsedFonts = [],
        fontsWithUsedUnsupportedFonts = []
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(FontSelect, Object.assign({
        dropdownClassName: "mce-hubspot-control",
        use: "on-dark",
        fonts: fontsWithUsedUnsupportedFonts,
        defaultFonts: fontsWithUsedUnsupportedFonts,
        webfonts: webfonts,
        parsedFonts: parsedFonts,
        enableParsedFonts: enableParsedFonts,
        customFonts: customFonts,
        fetchBrandingCustomFonts: getFetchBrandingCustomFonts(editor.settings.apiClient),
        addBrandingCustomFonts: addBrandingCustomFonts,
        value: value,
        onChange: getHandleChangeFont(editor),
        parsedFontText: parsedFontText,
        unsupportedFonts: UnsupportedFonts,
        isUngatedForBrandingFonts: isUngated(editor, 'AddBrandingFontsToRTE')
      }, rest));
    }
  });
}